import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  reduxForm, getFormValues, change, getFormSyncErrors,
} from 'redux-form';
import Modal from 'react-modal';
import { t } from 'i18next';
import putReduxPermissionList from './actions';
import {
  getAllPermissions,
  createCompany,
  updateCompany,
  deleteCompany,
  getCompanyInfo,
} from '../../services/companies';
import { formDataToApi, formApiToData } from '../../services/companies/helpers';
import {
  ButtonGroup,
  FormContainer,
  PageTitle,
  CategoryTitle,
} from './css';
import CompanyForm from './components/CompanyForm';
import { homeUrlNoTrailingSlash, openInNewTab } from '../../utils/func';
import { routes } from '../../utils/constants';
import LeavePageModal from '../ReactComponent/LeavePageModal';
import ModalBoxStyle from '../_styledComponents/ModalBoxStyle';
import {
  ModalTitle,
  Close,
  ModalBody,
  ButtonDiv,
} from '../ManageUsers/css';
import PrimaryButton from '../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../lib/ui/buttons/SecondaryButton';

const formName = 'CreateCompanyForm';
const initialValues = {
  accountList: [{}],
  division: 'Truckmate',
};

const ModalContent = ({ successAction, goToManage }) => (
  <>
    <ModalTitle>{t('Success')}</ModalTitle>
    <p>{successAction === 'create' ? t('NewCompanyCreated') : t('CompanyUpdated')}</p>
    <p>{t('You will now be taken to Manage Companies')}</p>
    <ButtonDiv>
      <SecondaryButton
        onClick={() => goToManage()}
        className="active min-width"
        showArrow={false}
      >
        {t('Accept')}
      </SecondaryButton>
    </ButtonDiv>
  </>
);

class CreateCompanyForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      permissionList: [],
      companyID: '',
      modalIsOpen: false,
      successModalIsOpen: false,
      successAction: '',
      viewEditCompanyData: [],
    };
  }

  componentDidMount() {
    this.fetchAllPermissions();
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('companyId')) {
      this.setState({ companyID: urlParams.get('companyId') });
      this.handleCompanyId(
        urlParams.get('companyId'),
      );
    }
  }

  componentDidUpdate(prevProps) {
    const { formData, dispatch } = this.props;
    const prevDivision = prevProps.formData && prevProps.formData.division;
    const currDivision = formData && formData.division;
    if (currDivision && currDivision !== prevDivision && prevDivision) {
      dispatch(change(formName, 'permissions', {}));
      this.fetchAllPermissions(currDivision, true);
    }
  }

  handleCompanyId(companyId) {
    getCompanyInfo(companyId)
      .then((response) => {
        if (response.data) {
          const { data } = response;
          this.setState({ viewEditCompanyData: response.data });
          const { permissionList } = this.state;
          const formedData = formApiToData(data, permissionList);
          this.dispatchFormValues(formedData);
        }
      });
  }

  dispatchFormValues = (data) => {
    const { dispatch } = this.props;
    Object.keys(data).map((field) => dispatch(change(formName, field, data[field])));
  };

  setShippingPermission = (data) => {
    const { dispatch } = this.props;

    const shippingPerm = data.filter((p) => p.permissionName === 'Shipping').map((sp) => ({
      [sp.permissionName]: {
        selected: ['',
          {
            name: sp.permissionName,
            desc: sp.description,
            code: sp.permissionId,
          }],
      },
    }));

    if (shippingPerm[0]) {
      dispatch(change(formName, 'permissions', { ...shippingPerm[0] }));
    }
  };

  fetchAllPermissions = (divisionOverride, reapplyCompanyPermissions) => {
    const { division, formData } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const divisionParam = divisionOverride || (formData && formData.division) || urlParams.get('division') || division;
    getAllPermissions(divisionParam).then((res) => {
      if (res.status === 200) {
        const { putReduxPermissionList } = this.props;
        putReduxPermissionList(res.data);
        this.setState({ permissionList: res.data });

        const { viewEditCompanyData } = this.state;
        if (reapplyCompanyPermissions && viewEditCompanyData && viewEditCompanyData.permissions) {
          const formedData = formApiToData(viewEditCompanyData, res.data);
          this.dispatchFormValues({ permissions: formedData.permissions });
        } else {
          this.setShippingPermission(res.data);
        }
      }
    });
  };

  goToManage = (e) => {
    if (e) {
      e.preventDefault();
    }

    const manageCompanyUrl = `${homeUrlNoTrailingSlash()}${routes.manageCompany}`;
    window.location.href = manageCompanyUrl;
  };

  deleteCompany = () => {
    const { companyID } = this.state;
    deleteCompany(companyID).then((res) => {
      if (res.status === 200 || res.status === 201 || res.status === 204) {
        this.goToManage();
      }
    });
  };

  handleSubmit = () => {
    const {
      formData,
      isAuthenticated,
      division,
    } = this.props;
    const { companyID } = this.state;
    const urlParams = new URLSearchParams(window.location.search);
    const divisionParam = formData.division || urlParams.get('division') || division;
    if (isAuthenticated) {
      const changedData = formDataToApi(formData, divisionParam);
      if (formData.rowVersion) {
        updateCompany(changedData, companyID).then((res) => {
          if (res.status === 200 || res.status === 201 || res.status === 204) {
            this.openModal('update');
          }
        });
      } else {
        createCompany(changedData).then((res) => {
          if (res.status === 200 || res.status === 201 || res.status === 204) {
            this.openModal('create');
          }
        });
      }
    }
  };

  openModal = (successAction) => {
    this.setState({
      successModalIsOpen: true,
      successAction,
    });
  };

  closeModal = () => {
    this.setState({ successModalIsOpen: false });
  };

  handleCreateUser = (e) => {
    e.preventDefault();
    const { formData, division: profileDivision } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const division = (formData && formData.division) || urlParams.get('division') || profileDivision;
    if (this.state.companyID) {
      const createUserURL = `${homeUrlNoTrailingSlash()}${routes.createUser}?page=${'manage-companies'}&division=${division}`;
      localStorage.setItem('view/editCompanyData', JSON.stringify(this.state.viewEditCompanyData));
      openInNewTab(createUserURL);
    } else {
      const createUserURL = `${homeUrlNoTrailingSlash()}${routes.createUser}?page=${'manage-companies'}&division=${division}`;
      openInNewTab(createUserURL);
    }
  };

  render() {
    const {
      formData, handleSubmit, dispatch, fields, formSyncErrors,
    } = this.props;
    const {
      permissionList, modalIsOpen, successModalIsOpen, successAction,
    } = this.state;
    return (
      <>
        <Modal
          isOpen={successModalIsOpen}
          // onRequestClose={this.closeModal}
          style={ModalBoxStyle}
          contentLabel="Modal"
        >
          <Close onClick={() => this.closeModal()} />
          <ModalBody className="justify-content-center">
            <ModalContent
              goToManage={this.goToManage}
              successAction={successAction}
            />
          </ModalBody>
        </Modal>
        <LeavePageModal isOpen={modalIsOpen} onClose={() => this.setState({ modalIsOpen: false })} onContinue={() => this.goToManage()} />
        <FormContainer>
          <form onSubmit={handleSubmit(this.handleSubmit)}>
            <PageTitle className="justified">
              {fields.pageHeading && fields.pageHeading.value}
            </PageTitle>
            <ButtonGroup>
              <PrimaryButton
                type="button"
                iconRightArrow
                className=" "
                onClick={(e) => this.handleCreateUser(e)}
                showArrow={false}
              >
                {t('AddNewUser')}
                <span className="" />
              </PrimaryButton>
              <PrimaryButton type="submit">
                <span className="" />
                {t('SaveChanges')}
              </PrimaryButton>
            </ButtonGroup>
            <CategoryTitle>
              {fields.categoryTitle && fields.categoryTitle.value}
            </CategoryTitle>

            <CompanyForm
              formData={formData}
              dispatch={dispatch}
              formName={formName}
              permissionList={permissionList}
              deleteCompany={this.deleteCompany}
              parentFields={fields}
              error={formSyncErrors}
            />
            <ButtonGroup>
              <SecondaryButton type="button" className="active" onClick={() => this.setState({ modalIsOpen: true })} isIconLeftPosition>
                {t('Cancel')}
              </SecondaryButton>
              <PrimaryButton type="submit" className="submit">
                {t('SaveChanges')}
              </PrimaryButton>
            </ButtonGroup>
          </form>
        </FormContainer>
      </>
    );
  }
}

CreateCompanyForm = reduxForm({
  form: formName, // a unique identifier for this form
  initialValues,
})(CreateCompanyForm);

const mstp = (state) => ({
  formData: getFormValues(formName)(state),
  formSyncErrors: getFormSyncErrors(formName)(state),
  isAuthenticated: state.profile.isAuthenticated,
  division: state.profile.division,
  email: state.profile.email,
});

const mdtp = (dispatch) => ({
  putReduxPermissionList: (permissionList) => dispatch(putReduxPermissionList(permissionList)),
});

export default connect(mstp, mdtp)(CreateCompanyForm);

CreateCompanyForm.propTypes = {
  formData: PropTypes.object,
  handleSubmit: PropTypes.func,
  dispatch: PropTypes.func,
  fields: PropTypes.shape({
    pageHeading: PropTypes.object,
    categoryTitle: PropTypes.object,
  }),
  formSyncErrors: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  division: PropTypes.string,
  putReduxPermissionList: PropTypes.func,
};

ModalContent.propTypes = {
  successAction: PropTypes.string,
  goToManage: PropTypes.func,
};

